module.exports = __webpack_public_path__ + "img/vertical_6_3_5012.276ce890.png";